import * as Yup from "yup";
import _ from "lodash";
import {useEffect, useState, useMemo} from "react";
import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {Button, Icon} from "~/components";
import {Alert, Col, Row, Tabs} from "antd";
import {InputField, SelectField} from "~/components/Forms";
import {useUtilities, useCan} from "~/hooks";
import DOMPurify from "dompurify";
import {Comments} from "../../../../components";
import {generateRandomString} from "../../../../utils";

function UploadWebsiteFormStep({item, onHandleHost, onHandleSource, onHandleUpload, onClickDevStatus, onHandleLoginHost}) {

	const [hostData, setHostData] = useState({});

	const [databaseData, setDatabaseData] = useState({});

	const [sourceData, setSourceData] = useState({
		source: '', database: ''
	});

	const [loadingDevStatus, setLoadingDevStatus] = useState(false);

	const [loginHost, setLoginHost] = useState(false);

	const [loginHostLoading, setLoginHostLoading] = useState(false);

	const can = {
		devStatus: useCan('uploadWebsiteDevStatus'),
	};

	const {utilities} = useUtilities();

	const sourceTypeOption = useMemo(() => {
		return [...Object.entries(utilities.devSource).map(([key, name]) => {
			return {
				value: key,
				label: name
			};
		})];
	}, [utilities.devSource]);

	let userName = item.domain.replace(/[^a-zA-Z0-9]/g, '').slice(0, 9);

	const { control: controlHost, handleSubmit: handleSubmitHost, formState: { isSubmitting: isSubmittingHost, errors: errorsHost }, setValue} = useForm({
		defaultValues: {
			hostUser: userName,
			hostPass: '',
		},
		resolver: yupResolver(Yup.object().shape({
			hostUser: Yup.string().required('Bạn chưa điền tên đăng nhập host'),
			hostPass: Yup.string().required('Bạn chưa điền mật khẩu host'),
		}))
	});

	const { control: controlSource, handleSubmit: handleSubmitSource, formState: { isSubmitting: isSubmittingSource, errors: errorsSource }} = useForm({
		defaultValues: {
			sourcePath: 'sikidodemo.com',
			sourceFolder: '',
			sourceDb: '',
		},
		resolver: yupResolver(Yup.object().shape({
			sourcePath: Yup.string().required('Bạn chưa chọn đường dẫn source code'),
			sourceFolder: Yup.string().required('Bạn chưa điền folder source code'),
		}))
	});

	const { control: controlUpload, handleSubmit: handleSubmitUpload, formState: { isSubmitting: isSubmittingUpload, errors: errorsUpload }} = useForm({
		defaultValues: {
			sourcePath: 'sikidodemo.com',
			sourceFolder: '',
			databaseName: '',
			databasePass: '',
		},
		resolver: yupResolver(Yup.object().shape({
			sourcePath: Yup.string().required('Bạn chưa chọn đường dẫn source code'),
			sourceFolder: Yup.string().required('Bạn chưa điền folder source code'),
			databaseName: Yup.string().required('Bạn chưa điền tên database'),
			databasePass: Yup.string().required('Bạn chưa điền mật khẩu database'),
		}))
	});

	useEffect(() => {
		setHostData({})
		setDatabaseData({})
		setValue('hostPass', generateRandomString(10));
	}, [item])

	const onSubmitHost = async (data) => {
		let response = await onHandleHost(data, item);
		if(response !== false)
		{
			if(response?.data?.host)
			{
				setHostData(response.data.host)
				setDatabaseData(response.data.database)
			}
			if(response?.data?.vpsId)
			{
				setLoginHost(true)
			}
		}
	}

	const onSubmitSource = async (data) => {
		let response = await onHandleSource(data, item);
		if(response !== false) {
			sourceData.source = response.data.urlSource;
			sourceData.database = response.data.urlDatabase;
			setSourceData(sourceData)
		}
	}

	const onSubmitUpload = async (data) => {
		let response = await onHandleUpload(data, item);
		if(response !== false) {
		}
	}

	const onLoginHost = async () => {
		setLoginHostLoading(true);
		await onHandleLoginHost(item);
		setLoginHostLoading(false);
	}

	const handleDevStatusClick = async (status) => {
		setLoadingDevStatus(true);
		if(!onClickDevStatus) return;
		await onClickDevStatus(status, item);
		setLoadingDevStatus(false);
	}

	const FormDownload = () => {
		return <form className="form" onSubmit={handleSubmitSource(onSubmitSource)}>
			<Controller control={controlSource} name="sourcePath" render={({ field }) => (
				<SelectField label="Đường dẫn" options={sourceTypeOption} errors={errorsSource} {...field}/>
			)}/>
			<Controller control={controlSource} name="sourceFolder" render={({field}) => (
				<InputField label="Tên thư mục demo" errors={errorsSource} {...field}/>
			)}/>
			<div className="form-group d-flex justify-content-end">
				<Button loading={isSubmittingSource} background red>Nén source</Button>
				{
					(sourceData.source) && <Button background blue href={sourceData.source} download>Tải source đã nén</Button>
				}
				{
					(sourceData.database) && <Button background red href={sourceData.database} download>Tải database đã nén</Button>
				}
			</div>
		</form>
	}

	const FormUploadWebsite = () => {
		return <form className="form" onSubmit={handleSubmitUpload(onSubmitUpload)}>
			<Row className="mb-2" gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={controlUpload} name="sourcePath" render={({ field }) => (
						<SelectField label="Đường dẫn" options={sourceTypeOption} errors={errorsUpload} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={controlUpload} name="sourceFolder" render={({field}) => (
						<InputField label="Tên thư mục demo" errors={errorsUpload} {...field}/>
					)}/>
				</Col>
			</Row>
			<Row className="" gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={controlUpload} name="databaseName" render={({field}) => (
						<InputField label="Tên database" errors={errorsUpload} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={controlUpload} name="databasePass" render={({field}) => (
						<InputField label="Mật khẩu database" errors={errorsUpload} {...field}/>
					)}/>
				</Col>
			</Row>
			<div className="form-group d-flex justify-content-end">
				<Button loading={isSubmittingUpload} background red>Tải lên host</Button>
			</div>
		</form>
	}

	const tabs = [
		{
			key: '1',
			label: 'Upload website',
			children: <FormUploadWebsite />
		},
		{
			key: '2',
			label: 'Tải source',
			children: <FormDownload />
		}
	];

	return (
		<Row className="mb-2" gutter={10}>
			<Col className="gutter-row" span={12}>
				<div className="form">
					<p className="heading">Thông tin</p>
					<Row className="mb-2" gutter={10}>
						<Col className="gutter-row" span={6}>Tên miền</Col>
						<Col className="gutter-row" span={18}>{`${item.domain}`}</Col>
					</Row>
					<Row className="mb-2" gutter={10}>
						<Col className="gutter-row" span={6}>Url Demo</Col>
						<Col className="gutter-row" span={18}>{`${item.url}`}</Col>
					</Row>
					<p className="heading">Thông tin host</p>
					{
						(item.hostType != 2 && item?.hostCreated == 0 && !loginHost) && <form className="form" onSubmit={handleSubmitHost(onSubmitHost)}>
							<Row className="" gutter={10}>
								<Col className="gutter-row" span={12}>
									<Controller control={controlHost} name="hostUser" render={({field}) => (
										<InputField label="Tên đăng nhập host" errors={errorsHost} {...field}/>
									)}/>
								</Col>
								<Col className="gutter-row" span={12}>
									<Controller control={controlHost} name="hostPass" render={({field}) => (
										<InputField label="Mật khẩu đăng nhập host" errors={errorsHost} {...field}/>
									)}/>
								</Col>
							</Row>
							<div className="form-group d-flex justify-content-end">
								<Button loading={isSubmittingHost} background red>Tạo host</Button>
							</div>
						</form>
					}
					{
						((item.hostType !== 2 && item?.hostCreated !== 0) || loginHost) && <>
							<Alert message="Host đã được chia" type="warning"/>
							<div className="form-group d-flex justify-content-end mt-1">
								<Button loading={loginHostLoading} background blue onClick={onLoginHost}>Đăng nhập host</Button>
							</div>
						</>
					}
					{
						(item.hostType === 2) && <div className="text-sm" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.hostCustomer) }} />
					}
					<Row className="mb-2" gutter={10}>
						{
							(!_.isEmpty(hostData)) && <Col className="gutter-row" span={12}>
								<div className="pd-1" style={{background:'#c6fbc5', borderRadius:'5px'}}>
									<p><b>Thông tin host</b></p>
									<p>Ip: {hostData?.ip}</p>
									<p>Username: {hostData?.username}</p>
									<p>Package: {hostData?.package}</p>
									<p>
										<Button loading={loginHostLoading} background blue onClick={onLoginHost}>Đăng nhập host</Button>
									</p>
								</div>
							</Col>
						}
						{
							(!_.isEmpty(databaseData)) && <Col className="gutter-row" span={12}>
								<div className="pd-1" style={{background:'#ffbdbd', borderRadius:'5px'}}>
									<p><b>Thông tin database</b></p>
									<p>Database: {databaseData?.databaseName}</p>
									<p>Username: {databaseData?.username}</p>
									<p>Password: {databaseData?.password}</p>
								</div>
							</Col>
						}
					</Row>
					<Tabs defaultActiveKey="1" items={tabs} />

					<div className="form-group d-flex justify-content-end modal-bottom">
						{
							(can.devStatus && item.devStatus == 'up-wait') && (<Button loading={loadingDevStatus} onClick={() => handleDevStatusClick('success')} background green leftIcon={Icon.success}>Đã upload website</Button>)
						}
					</div>
				</div>
			</Col>
			<Col className="gutter-row" span={12}><Comments type="upload-website" objectId={item.id} /></Col>
		</Row>
	)
}

export default UploadWebsiteFormStep;